/**
 * Platform Admin Type Definitions
 * Hierarchical admin system with three distinct roles
 */

export type PlatformAdminRole = 
  | 'super_admin' 
  | 'admin_manager' 
  | 'admin_consultant' 
  | null;

export interface PlatformAdminPermissions {
  can_access_all_orgs: boolean;
  can_proxy_any_user: boolean;
  can_view_audit_logs: boolean;
  can_manage_platform: boolean;
  can_grant_admin_roles: boolean;
  can_revoke_admin_roles: boolean;
  can_delete_organizations: boolean;
  can_export_all_data: boolean;
  can_modify_system_settings: boolean;
  requires_mfa: boolean;
  requires_justification: boolean;
  max_proxy_duration_hours: number | null;
}

export interface PlatformAdminInfo {
  isAdmin: boolean;
  adminRole: PlatformAdminRole;
  permissions: PlatformAdminPermissions;
}

export interface PlatformAdminAuditEntry {
  id: string;
  admin_user_id: string;
  admin_role: PlatformAdminRole;
  action_type: string;
  target_type?: string;
  target_id?: string;
  organization_id?: string;
  justification?: string;
  metadata: Record<string, any>;
  ip_address?: string;
  performed_at: string;
  session_id?: string;
}

export interface PlatformProxyOptions {
  targetUserId: string;
  organizationId: string;
  justification?: string;
  duration?: number; // minutes
}

export const ROLE_LABELS: Record<NonNullable<PlatformAdminRole>, string> = {
  super_admin: 'Super Admin',
  admin_manager: 'Administrator (Manager)',
  admin_consultant: 'Administrator'
};

export const ROLE_COLORS: Record<NonNullable<PlatformAdminRole>, string> = {
  super_admin: 'bg-red-100 border-red-500 text-red-800',
  admin_manager: 'bg-yellow-100 border-yellow-500 text-yellow-800',
  admin_consultant: 'bg-blue-100 border-blue-500 text-blue-800'
};
